// TODO: Remove this file in favor of AskTechParser
var LightMarkdown = new (class LightMarkdown extends AbstractModule {

  constructor() {
    super("LightMarkdown");
    this._tokens                  = this._getTokens();
    this._slaaskRegex             = this._getRegex(this._tokens),
    this._plainToken              = '₪₪PLaiN₪₪',
    this._slaaskMarkdownOptions   = {},
    this._flavors = {
      slack: {
        bold: true,
        italics: true,
        strikethrough: true,
        pre: true,
        code: true,
        longQuote: true,
        quote: true,
        autoLink: true,
        autoEmail: true,
        autoImage: true,
        paragraph: true,
        lineBreaks: true
      },
      skype: {
        bold: true,
        italics: true,
        strikethrough: true,
        pre: false,
        code: false,
        longQuote: false,
        quote: false,
        autoLink: true,
        paragraph: false,
        lineBreaks: true
      }
    };

    this.setFlavor('slack');
  }

  _initData(data) {
    this._autoInit({
      "_loading_button_value": [
        data.widget.loading_button_value,
        ""
      ]
    });
  }


  /**
   * Set a global option
   * @static
   * @param {string} key
   * @param {*} value
   * @returns {lightMarkdown}
   */
  setOption(key, value) {
    this._slaaskMarkdownOptions[key] = !!value;
    return this;
  };

  /**
   * Get a global option
   * @static
   * @param {string} key
   * @returns {*}
   */
  getOption(key) {
    return this._slaaskMarkdownOptions[key];
  };


  setFlavor(flavorName) {
    var flavor = this._flavors[flavorName];
    if (flavor) {
      for (var option in flavor) {
        if (flavor.hasOwnProperty(option)) {
          this._slaaskMarkdownOptions[option] = flavor[option];
        }
      }
    }
    return this;
  };


  toHtml(md, noEmbedly, inWidget = true) {
    md = this._escapeHtml(md);
    var plains = [];

    // Replace all tokens
    this._tokens.forEach((t) => {
      if (this._slaaskMarkdownOptions[t.name]) {
        md = md.replace(t.regex, (match, g1, g2) => {
          if (!g2 ||
            t.requireNonTokens && !this._slaaskRegex.nonTokensChars.test(g2) ||
            (t.token.length === 1 && (g2[0] === t.token || g2.slice(-1) === t.token)) ||
            t.spaceWrapIgnored && g2[0] === ' ' && g2.slice(-1) === ' ')
            return match;

           if (typeof t.processContent === 'function') {
            g2 = t.processContent(g2);
          }
          if (t.plainContent) {
            var plainIndex = plains.push(g2) - 1;
            g2 = this._plainToken + plainIndex;
          }
          return g1 + '<' + t.elementName + '>' + g2 + '</' + t.elementName + '>';
        });
      }
    });

    if (this._slaaskMarkdownOptions.longQuote) {
      md = md.replace(this._slaaskRegex.multilineQuote, (match, g1, g2) => {
        if (match === '&gt;&gt;&gt;')
          return match;

        // trim start unless there are more '>' ahead
        g2 = g2.replace(/^([\s]*)(&gt;)*/, (m, gg1, gg2) => {
          return gg2 ? m : '';
        });
        return '<pre>' + g2 + '</pre>';
      });
    }

    if (this._slaaskMarkdownOptions.quote) {
      md = md.replace(this._slaaskRegex.singleLineQuote, (match, g1, g2) => {
        if (match === '&gt;')
          return match;
        g2 = g2.replace(/\n&gt;/g, '\n');
        return '<pre>' + g2 + '</pre>';
      });
    }

    if (this._slaaskMarkdownOptions.autoLink) {
      // Replace links
      let embedlyCard = ''

      md = md.replace(this._slaaskRegex.url, (match, g1, g2) => {
        match = match.replace('&lt;', '');
        match = match.replace('&gt;', '');

        var linkToReturn = null

        if(match.substr(0, 1) == '!') {
          noEmbedly = true
        }

        // GOOGLE DOCS

        if (match.match('docs.google.com')) {
          linkToReturn = '<a href="' + match + '" target="_blank" class="">' + match + '</a>';
        }

        // GIPHY

        if (match.match('giphy.com')) {
          linkToReturn = '<img class="slaask-message-gif" src="' + match + '" />'
          // https://media.giphy.com/media/3oz8xSjBmD1ZyELqW4/giphy.gif
          // linkToReturn = '<iframe src="https://giphy.com/embed/' + match.split('/media/')[1].split('/')[0] +'" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>';
        }

        if (match.indexOf('|') != -1 && match.substring(match.indexOf('|') + 1, match.length) != '') {
          let match1 = match.substring(0, match.indexOf('|'))
          let match2 = match.substring(match.indexOf('|') + 1, match.length)

          if (match1.indexOf('https://files.slack.com') == -1) {
            linkToReturn = '<a href="' + match1 + '" target="_blank" class="">' + match2 + '</a>';
          } else {
            if (!noEmbedly) {
              noEmbedly   = true
              embedlyCard = '<a href="' + this.app._cdn_url + '/proxy/images?url=' + match1 + '&token=' + this.app._api_key + '&title=' + match2 + '" target="_blank" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">'+this._loading_button_value+'</a>';
            }
            linkToReturn = '<a class="" href="' + this.app._cdn_url + '/proxy/images?url=' + match1 + '&token=' + this.app._api_key + '&title=' + match2 + '" target="_blank">' + match2 + '</a>';
          }
        } else {
          if (match.indexOf('https://files.slack.com') == -1) {
            if (!noEmbedly) {
              noEmbedly   = true
              embedlyCard = '<a href="' + match + '" target="_blank" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">'+this._loading_button_value+'</a>';
            }
            linkToReturn = '<a href="' + match + '" target="_blank" class="">' + match + '</a>';
          } else {
            if (!noEmbedly) {
              noEmbedly   = true
              embedlyCard =  '<div class="slaask-link-container"><a href="' + this.app._cdn_url + '/proxy/images?url=' + match + '&token=' + this.app._api_key + '&title=' + match + '" target="_blank" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">'+this._loading_button_value+'</a></div>';
            }
            linkToReturn = '<a href="' + this.app._cdn_url + '/proxy/images?url=' + match + '&token=' + this.app._api_key + '&title=' + match + '" target="_blank". class="">' + match + '</a>';
          }
        }

        if(match.substr(0, 1) == '!') {
          linkToReturn = linkToReturn.replace('class="', 'class="slaask-btn ').replace('!http', 'http').replace('_blank', '_self')
        }

        return linkToReturn
      });

      md = md + embedlyCard
    }

    if (this._slaaskMarkdownOptions.autoEmail) {
      // Replace links
      md = md.replace(this._slaaskRegex.email, (match, g1, g2) => {
        match = match.replace('&lt;', '');
        match = match.replace('&gt;', '');
        return '<a href="' + match + '" target="_blank">' + match.replace('mailto:', '') + '</a>';
      });
    }

    if (this._slaaskMarkdownOptions.autoImage) {
      // Replace links
      md = md.replace(this._slaaskRegex.image, (match, g1, g2, g3, g4, g5) => {
        if (g4.indexOf('https://files.slack.com') == -1) {
          if (g4.indexOf('https://slack-files.com') == -1) {
            if (g4.indexOf('dropbox.com/s/') != -1) {
              if (g4.match('dl=0')) {
                g4 = g4.replace('dl=0', 'raw=1')
              } else {
                g4 = g4 + '?raw=1'
              }
            }

            if (this.app.getScreenWidth() > 780 && !noEmbedly) {
              return '<a href="' + g4 + '" target="_blank" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">' + g2 + '</a>';
            } else {
              return '<a href="' + g4 + '" target="_blank"><img' + (inWidget ? ' onload="window.' + this.app._mainObject(Dom.isInIframe()) + '.handleImageLoad(event.currentTarget);"' : '') + ' src="' + g4 + '"/></a>'
            }
          } else {
            return '<a href="' + g4 + '" target="_blank" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">'+this._loading_button_value+'</a>';
            // return '<a href="' + g4 + '" target="_blank" data-card-type="image" class="" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">' + g2 + '</a>';
          }
        } else {
          if (this.app.getScreenWidth() > 780 && !noEmbedly) {
            return '<a href="' + this.app._cdn_url + '/proxy/images?url=' + g4 + '&token=' + this.app._api_key + '" target="_blank" class="" data-card-type="image" data-card-controls="0" data-card-key="a61ceacdd662457fa5189966e6fa04fa" data-card-align="left">' + g2 + '</a>';
          } else {
            return '<a href="' + this.app._cdn_url + '/proxy/images?url=' + g4 + '&token=' + this.app._api_key + '" target="_blank"><img' + (inWidget ? ' onload="window.' + this.app._mainObject(Dom.isInIframe()) + '.handleImageLoad(event.currentTarget);"' : '') + ' src="' + this.app._cdn_url + '/proxy/images?url=' + g4 + '&token=' + this.app._api_key + '"/></a>'
          }
        }
      });
    }

    if (this._slaaskMarkdownOptions.paragraph) {


      // Create paragraphs
      var m;
      var doubleLineIndexes = [];
      while ((m = this._slaaskRegex.doubleLineBreak.exec(md))) {
        doubleLineIndexes.push({
          start: m.index,
          length: m[0].length
        });
      }
      while ((m = this._slaaskRegex.blockquoteTags.exec(md))) {
        doubleLineIndexes.push({
          start: m.index,
          length: m[0].length,
          suffix: m[0]
        });
      }
      doubleLineIndexes.push({
        start: md.length,
        length: 0
      });

      doubleLineIndexes.sort((a, b) => {
        return a.start - b.start;
      });

      var withParagraphs = '';
      var startIndex = 0;
      doubleLineIndexes.forEach((doubleLine) => {
        var paragraph = '';
        var paragraphContent = md.substring(startIndex, doubleLine.start);
        if (paragraphContent) {
          paragraph = '<p>' + paragraphContent + '</p>';
        }
        if (doubleLine.suffix) {
          paragraph += doubleLine.suffix;
        }
        withParagraphs += paragraph;
        startIndex = doubleLine.start + doubleLine.length;
      });
      md = withParagraphs;
    }

    if (this._slaaskMarkdownOptions.lineBreaks) {
      // Create line breaks
      md = md.replace(this._slaaskRegex.singleLineBreak, '<br/>');
    }
    // Restore plain parts
    plains.forEach((p, plainIndex) => {
      md = md.replace(this._plainToken + plainIndex, p);
    });

    return md;
  };


  _escapeHtml(content) {
    if (content) {
      content = content.replace(/>/g, '&gt;');
      content = content.replace(/</g, '&lt;');
    }
    return content;
  }

  _getRegex(tokens) {
    var allTokenChars = tokens.map((t) => {
      return t.token.length === 1 ? t.token : '';
    }).join();

    var nonTokensCharsRegex = new RegExp('[^' + allTokenChars + ']');

    // Multiline quote >>>
    var multilineQuoteRegex = /(^|\n)&gt;&gt;&gt;([\s\S]*$)/;

    // Single line quote > or sequential lines that start with >.
    var singleLineQuoteRegex = /(^|\n)&gt;(([^\n]*)(\n&gt;[^\n]*)*)/g;

    // Two new lines in a row
    var doubleLineBreakRegex = /\r?\n\r?\n\r?/g;

    // Single line break
    var singleLineBreakRegex = /\r?\n\r?/g;

    // var urlRegex = /(&lt;https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\_\&\?\=\%\.\-]*)(\|)?([\S]+)?((&gt)?;)?/gi;
    var urlRegex = /(&lt;!?https?:\/\/(.*?)(|)?(.*?)?&gt;)/gi;

    var emailRegex = /(&lt;mailto:)((([\da-z+\.-]+)\@([a-z0-9\.]{2,6})([\/\w \.-]*)(\|)?([\da-z\.-]+)?\.?([a-z\.]{2,6})?)|(\{\{[\w]+\}\}))(&gt;)?/gi;

    var imageRegex = /(!\[)(.*?)(\]\()(https?:\/\/(.*?))(\))/gi;

    return {
      nonTokensChars: nonTokensCharsRegex,
      multilineQuote: multilineQuoteRegex,
      singleLineQuote: singleLineQuoteRegex,
      blockquoteTags: /<\/?blockquote>/ig,
      doubleLineBreak: doubleLineBreakRegex,
      singleLineBreak: singleLineBreakRegex,
      url: urlRegex,
      email: emailRegex,
      image: imageRegex
    };
  }

  // From http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
  _escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  }

  _getTokens() {
    var tokens = [
      {name: 'pre', token: '```', elementName: 'pre', multiline: true, plainContent: true},
      {name: 'code', token: '`', elementName: 'code', ignoreAfter: true, plainContent: true},
      {name: 'bold', token: '*', elementName: 'b', requireNonTokens: true, spaceWrapIgnored: true},
      {name: 'italics', token: '_', elementName: 'em', requireNonTokens: true},
      {name: 'strikethrough', token: '~', elementName: 's', requireNonTokens: true, spaceWrapIgnored: true}
    ];
    tokens.forEach((t) => {
      if (!t.regex) {
        var before = '(^|[\\s\\?\\.,\\-!\\^;:{(\\[%$#+="])';
        var content = t.multiline ? '([\\s\\S]*?)?' : '(.*?\\S *)?';
        var after = t.ignoreAfter ? '' : '(?=$|\\s|[\\?\\.,\'\\-!\\^;:})\\]%$~{\\[<#+="])';
        var token = this._escapeRegExp(t.token);
        var pattern = before + token + content + token + after;
        t.regex = new RegExp(pattern, 'g');
      }
    });
    return tokens;
  }


});
